// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ModificationsContext from "./ModificationsContext.bs.js";

var make = ModificationsContext.context.Provider;

function makeProps(value, children, param) {
  return {
          value: value,
          children: children
        };
}

export {
  make ,
  makeProps ,
  
}
/* make Not a pure module */
